"use strict";
/* eslint-disable indent */
// eslint and prettier are fighting each other over the case statement indentation
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidationClient = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var querystring_1 = require("querystring");
var endpointURL = "https://secure.shippingapis.com/ShippingAPI.dll";
/**
 * USPS Address Validation API Client
 * @see https://www.usps.com/business/web-tools-apis/
 *
 * @export
 * @class AddressValidationClient
 */
var AddressValidationClient = /** @class */ (function () {
    function AddressValidationClient(client) {
        if (client === void 0) { client = null; }
        if (client) {
            this._client = client;
        }
        else {
            this._client = axios_1.default.create();
            // clear any headers that might be configured by default
            this._client.defaults.headers = [];
        }
    }
    /**
     * Validates the given address.
     * The Address Standardization Web Tool corrects errors in street addresses, including abbreviations and
       missing information, and supplies ZIP Codes and ZIP Codes + 4. It supports up to five lookups per
       transaction.
     *
     * @param {string} userId
     * @param {IAddress} address
     * @returns {Promise<IAddress>}
     * @memberof AddressValidationClient
     */
    AddressValidationClient.prototype.validate = function (userId, address) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var addresses, validatedAddresses;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addresses = [address];
                        return [4 /*yield*/, this.validateAddresses(userId, addresses)];
                    case 1:
                        validatedAddresses = _a.sent();
                        if (validatedAddresses.length > 0) {
                            return [2 /*return*/, validatedAddresses[0]];
                        }
                        return [2 /*return*/, Promise.reject(this.fail())];
                }
            });
        });
    };
    /**
     * Validates the given addresses.
     * The Address Standardization Web Tool corrects errors in street addresses, including abbreviations and
       missing information, and supplies ZIP Codes and ZIP Codes + 4. It supports up to five lookups per
       transaction.
     *
     * @param {string} userId
     * @param {Address[]} addresses
     * @returns {Promise<Address[]>}
     * @memberof AddressValidationClient
     */
    AddressValidationClient.prototype.validateAddresses = function (userId, addresses) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var addressXml, xml, request, response, domParser, responseDoc, errorElement, addresses_1;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressXml = "";
                        addresses.forEach(function (address, index) {
                            addressXml +=
                                "<Address ID=\"" + (address.id || index) + "\">" +
                                    ("<Address1>" + (address.address1 || "") + "</Address1>") +
                                    ("<Address2>" + (address.address2 || "") + "</Address2>") +
                                    ("<City>" + (address.city || "") + "</City>") +
                                    ("<State>" + (address.state || "") + "</State>") +
                                    ("<Zip5>" + (address.zip5 || "") + "</Zip5>") +
                                    ("<Zip4>" + (address.zip4 || "") + "</Zip4>") +
                                    "</Address>";
                        });
                        xml = "<AddressValidateRequest USERID=\"" + userId + "\">" + addressXml + "</AddressValidateRequest>";
                        request = { API: "Verify", XML: xml };
                        return [4 /*yield*/, this._client.post(endpointURL, (0, querystring_1.stringify)(request))];
                    case 1:
                        response = _a.sent();
                        domParser = new DOMParser();
                        responseDoc = domParser.parseFromString(response.data, "text/xml");
                        switch (responseDoc.documentElement.tagName) {
                            case "AddressValidateResponse": {
                                errorElement = responseDoc.querySelector("Error");
                                if (errorElement) {
                                    return [2 /*return*/, Promise.reject(this.handleErrorElement(errorElement))];
                                }
                                addresses_1 = new Array();
                                responseDoc
                                    .querySelectorAll("Address")
                                    .forEach(function (addressElement) {
                                    var address = {};
                                    address.address1 = _this.getValue(addressElement, "Address1");
                                    address.address2 = _this.getValue(addressElement, "Address2");
                                    address.city = _this.getValue(addressElement, "City");
                                    address.state = _this.getValue(addressElement, "State");
                                    address.zip4 = _this.getValue(addressElement, "Zip4");
                                    address.zip5 = _this.getValue(addressElement, "Zip5");
                                    addresses_1.push(address);
                                });
                                return [2 /*return*/, addresses_1];
                            }
                            case "Error": {
                                return [2 /*return*/, Promise.reject(this.handleErrorElement(responseDoc))];
                            }
                            default: {
                                return [2 /*return*/, Promise.reject(this.fail())];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddressValidationClient.prototype.fail = function () {
        return { description: "Failed" };
    };
    AddressValidationClient.prototype.handleErrorElement = function (element) {
        return {
            description: this.getValue(element, "Description"),
            number: this.getValue(element, "Number"),
            source: this.getValue(element, "Source")
        };
    };
    AddressValidationClient.prototype.getValue = function (containerElement, innerElementName) {
        var element = containerElement.querySelector(innerElementName);
        if (element) {
            return element.innerHTML;
        }
        return undefined;
    };
    return AddressValidationClient;
}());
exports.AddressValidationClient = AddressValidationClient;
//# sourceMappingURL=AddressValidationClient.js.map